"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var string_util_1 = require("./string_util");
function getSafely(hash, keyStr, defaultVal) {
    if (hash === void 0) { hash = {}; }
    if (defaultVal === void 0) { defaultVal = null; }
    if (!hash) {
        return defaultVal;
    }
    var keys = keyStr.split('.');
    if (keys.length === 1) {
        return hash[keys[0]] || defaultVal;
    }
    var remainingKeys = keys.slice(1);
    var newHash = hash[keys[0]];
    if (newHash) {
        return getSafely(newHash, remainingKeys.join('.'), defaultVal);
    }
    return newHash || defaultVal;
}
exports.getSafely = getSafely;
function getLink(obj, name) {
    return getSafely(obj, "_links." + name + ".href");
}
exports.getLink = getLink;
function camelizeKeys(hash) {
    if (hash === void 0) { hash = {}; }
    var newHash = {};
    Object.keys(hash).forEach(function (key) {
        var camelizedKey = string_util_1.default.underscoreToCamelCase(key);
        var value = hash[key];
        newHash[camelizedKey] = value;
    });
    return newHash;
}
exports.camelizeKeys = camelizeKeys;
function underscoreKeys(hash) {
    if (hash === void 0) { hash = {}; }
    var newHash = {};
    Object.keys(hash).forEach(function (key) {
        var underscoredKey = string_util_1.default.camelCaseToUnderscore(key);
        var value = hash[key];
        newHash[underscoredKey] = value;
    });
    return newHash;
}
exports.underscoreKeys = underscoreKeys;
function rejectBlankValues(hash) {
    if (hash === void 0) { hash = {}; }
    var newHash = {};
    Object.keys(hash).forEach(function (key) {
        var value = hash[key];
        if (value !== '' && value !== undefined && value !== null) {
            newHash[key] = value;
        }
    });
    return newHash;
}
exports.rejectBlankValues = rejectBlankValues;
exports.default = {
    getSafely: getSafely,
    getLink: getLink,
    camelizeKeys: camelizeKeys,
    underscoreKeys: underscoreKeys,
    rejectBlankValues: rejectBlankValues,
};
//# sourceMappingURL=hash_util.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/hash_util.js
// module id = CLM6
// module chunks = 20 21 22